import { LayoutDashboard, RefreshCw, TriangleAlert } from 'lucide-react';
import { BrandStatusPage } from './BrandStatusPage';

export interface RouteErrorFallbackProps {
  onRetry?: () => void;
  /** Optional short message; never show stack traces. */
  message?: string;
}

/**
 * In-shell fallback for per-route ErrorBoundary crashes.
 */
export function RouteErrorFallback({
  onRetry,
  message = 'This section encountered an unexpected error. You can try again or head back to the dashboard.',
}: RouteErrorFallbackProps): JSX.Element {
  return (
    <BrandStatusPage
      layout="embedded"
      tone="coral"
      heroTone="coral"
      heroSize="md"
      heroMotion="shake"
      showLogo={false}
      hero={
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-coral-100">
          <TriangleAlert className="h-8 w-8 text-coral-600" aria-hidden />
        </div>
      }
      title="Something went wrong"
      description={message}
      primaryAction={
        onRetry
          ? {
              label: 'Try again',
              onClick: onRetry,
              icon: RefreshCw,
              variant: 'coral',
            }
          : undefined
      }
      secondaryAction={{
        label: 'Go to Dashboard',
        to: '/',
        icon: LayoutDashboard,
        variant: 'secondary',
      }}
      footer="Route error · DentXE"
    />
  );
}
